import React from 'react';
import assessmentReader from '../../store/readHelpers/AssessmentReader';
import styles from './answerKeys.scss';
import SectionAnswerKeys from './SectionAnswerKeys';
import sessionReader from '../../store/readHelpers/SessionReader';

const AnswerKeys = () => {
    const isQuestionInPrintView = sessionReader.isModeQuestionInPrintView();
    const wrapperClasses = `${styles.answerKeysWrapper} ${isQuestionInPrintView ? styles.printAnswerKeyQuestion : ''}`;

    return (<div className={wrapperClasses}>
        <table className={styles.answerKeys}>
            <colgroup>
                <col className={styles.questionNumberColumn} />
                <col className={styles.answerKeysColumn} />
            </colgroup>
            <tbody>
                {assessmentReader.getSections().map(section => (
                    <SectionAnswerKeys key={section.id} section={section} />
                ))}
            </tbody>
        </table>
    </div>);
};

export default AnswerKeys;
